// extracted by mini-css-extract-plugin
module.exports = {"textDisplay":"TextDisplay_textDisplay__2ho8C"};